<template>
    <v-app :dark="isDarkTheme" class="relative-position ypo-app">
        <v-content>
            <!--TODO: Header component needs refactoring when we have a story-->
            <router-view name="header"></router-view>
            <router-view :key="$route.fullPath"></router-view>
        </v-content>
        <v-dialog v-model="showModal"
                  v-if="sessionExpiry || inactiveSessionDetected"
                  scrollable
                  data-qe-id="SessionWarning" width="800"
                  content-class="medium"
                  persistent>
            <v-card class="my-profile-popup">
                <v-card-title>
                    <span class="my-profile-popup__title">{{sessionNotificationTitle}}</span>

                    <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="closeSessionNoticeDialog"></i>
                </v-card-title>
                    <v-card-text class="inner-scrollbar">
                        <v-flex xs-12 class="details-view" v-html=sessionNotificationMessage>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-flex text-xs-right pa-3>
                            <v-btn flat class="primary_btn"  @click=closeSessionNoticeDialog()  data-qe-id="session_closeBtn">
                                {{appCommonConstants.OK}}
                            </v-btn>
                        </v-flex>
                    </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="loading-overlay" v-if="isCoreContentLoadingInProgress"></div>
        <!-- Global Snackbar -->
        <v-snackbar
            v-model="snackbar.visible"
            :timeout="3000"
            top
            right
            :color="snackbar.color"
            transition="v-snackbar-transition"
        >
            <span class="snackbar-message">{{ snackbar.message }}</span>
        </v-snackbar>
    </v-app>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeGetters } from "./store/storeGetters.constant";
    import { storeMutation } from "./store/storeMutations.constant";
    import { storeAction } from "./store/storeActions.constant";
    import { loadAppInsight } from "./app.utils";
    import { userRoles, routerNames, appCommonConstants } from "./components/appCommon.constants";
    import store from "./store/store";

    export default {
        name: "App",
        beforeCreate() {
            loadAppInsight();
        },
        created() {
            this.loginPrivacyTermsOfUse();
        },
        data() {
            return {
                appCommonConstants,
                userRoles,
                routerNames,
                showModal: false,
            };
        },
        computed: {
            ...mapGetters({
                userPermissionsData: `auth/${storeGetters.permissionsData}`,
                isDarkTheme: `appSettings/${storeGetters.appTheme}`,
                isAuthenticated: `auth/${storeGetters.isAuthenticated}`,
                mainPageOverflow: `${[storeGetters.getMainPageOverflow]}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                sessionExpiry: `${storeGetters.sessionExpiry}`,
                inactiveSessionDetected: `${storeGetters.inactiveSessionDetected}`,
                isCoreContentLoadingInProgress: `${[storeGetters.isCoreContentLoadingInProgress]}`,
            }),
            ...mapState('snackbar', {  
                snackbar: state => state
            }),
            isGroupSuperAdmin() {
                return this.userPermissionsData && this.userPermissionsData.userRoles && this.userPermissionsData.userRoles.some(o => o === "Group Super Administrator");
            },
            sessionNotificationTitle() {
              return this.inactiveSessionDetected ? appCommonConstants.SESSION_EXPIRED_LABEL : appCommonConstants.SESSION_WARNING;
            },
            sessionNotificationMessage() {
              return this.inactiveSessionDetected ? appCommonConstants.SESSION_IDLE_TIMEOUT : appCommonConstants.SESSION_USER_WARNING;
            },
        },
        watch: {
            mainPageOverflow(val) {
              document.querySelector('html').style.overflow = val ? 'hidden' : 'auto';
            },
            sessionExpiry() {
              this.showModal = !!this.sessionExpiry;
            },
            inactiveSessionDetected() {
                this.showModal = !!this.inactiveSessionDetected;
            },
            async $route(to) {
                this.setCurrentCommunityView(this.userRoles.MEMBER);
                this.setIsCommunityAdmin(false);
                if (this.$route.name === this.routerNames.GROUP && !to.params.communityId && this.isGroupSuperAdmin) {
                    this.setCurrentCommunityView(this.userRoles.ADMIN);
                }
                if (to.params.communityId) {
                    this.getCommunityById();
                    if (to.name === this.routerNames.NETWORK || to.name === this.routerNames.GROUP) {
                        this.getCommunityPendingRequests();
                    }
                } else if (to.name === routerNames.CHAMPS_PAGE) {
                    await this.getCommunityByName({ communityType: 'chapter', communityName: to.query.chapterName });
                }
            },
        },
        methods: {
            ...mapActions({
                getCommunityByName: `chapter/${storeAction.getCommunityByName}`,
                getCommunityById: `chapter/${storeAction.getCommunityById}`,
                getCommunityPendingRequests: `network/${storeAction.getCommunityPendingRequests}`,
                loginPrivacyTermsOfUse: `openAPI/${storeAction.loginPrivacyTermsOfUse}`,
            }),
            ...mapMutations({
                setIsCommunityAdmin: `chapter/${[storeMutation.setIsCommunityAdmin]}`,
                setCurrentCommunityView: `${[storeMutation.setCurrentCommunityView]}`,
                setSessionExpiryNotice: `${[storeMutation.setSessionExpiryNotice]}`,
                setInactiveSessionDetection: `${[storeMutation.setInactiveSessionDetection]}`,
            }),
            closeSessionNoticeDialog() {
              this.showModal = false;
              if (this.inactiveSessionDetected) {
                store.commit(storeMutation.setInactiveSessionDetection);
                window.location.reload();
              }
                if (this.sessionExpiry) store.commit(storeMutation.setSessionExpiryNotice);
            },
        },
    };
</script>

<style lang="scss">
    @import './common/styles/_colors.scss';
    @import './common/styles/_commonClasses.scss';
    @import 'common/styles/_ypo-auth.scss';

    body {
        margin: 0;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
        box-shadow: 0 0 0 1000px transparent inset;
        transition: background-color 5000s ease-in-out 0s;
    }

    body,
    .application,
    .v-input input,
    .v-input .v-label {
        font-family: Noto Sans, sans-serif;
    }

    #surveyContent {
        .btn-open-survey {
            left: 0;
        }
    }

    h3,
    h4 {
        font-family: Raleway, serif;
    }

    * {
        box-sizing: border-box !important;
    }

    .v-input--selection-controls__input+.v-label {
        font-weight: 600;
        color: $ypo-blue !important;
        font-size: 16px;
    }

    .my-profile-popup {
        .v-card__title {
            background-color: $ypo-tile-border;
            color: $ypo-blue;
            font-family: Raleway;
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            position: relative;
            display: inline-block;

          &__title {
            width: 95%;
          }

            i {
                color: $ypo-cta;
                position: absolute;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    .ypo-app {
      .loading-overlay {
        background-image: url(/loading_transition.gif);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-color: #fbfbfb;
        z-index: 100;
      }
      
      .snackbar-message {
        font-weight: 700;
        font-size: '14px';
      }
    }


</style>
